var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-5"},[_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":_vm.width}},[_c('v-card-text',{staticClass:"text-justify text-md-body-1 text-xs-body-2 black--text",staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.text))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }